





























import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import { ILoginCredentials, IAuthResponse } from '../api/auth.interfaces';

@Component({})
export default class Login extends Vue {
  loading: boolean = false;
  valid: boolean = false;

  user: ILoginCredentials = { email: '', password: '', grant: 'password' };

  $refs: {
    form: any;
  };

  handleLogin(event: any) {
    if (this.$refs.form.validate()) {
      var self = this;
      self.loading = true;

      this.$store
        .dispatch('auth/login', this.user)
        .then((response: IAuthResponse) => {
          self.$router.push('/dashboard');
          self.loading = false;
        })
        .catch((error: any) => {
          self.loading = false;
        });
    }
  }
}
